<template>
  <el-card
    class="text-left"
    shadow="never">
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button
          type="primary"
          @click="handleAdd">
          新增
        </el-button>
      </el-col>
      <el-col :span="17">
        <el-form :inline="true" label-width="80px">
          <el-form-item>
            <el-input
              v-model="searchKeyword"
              placeholder="请输入关键字"
              suffix-icon="el-icon-search" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchIsVisible" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleRefresh">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '上架',
          value: '1',
        },
        {
          label: '下架',
          value: '0',
        },
      ]
    }
  },
  props: {
    is_visible: {
      type: String,
      require: true
    },
    keyword: {
      type: String,
      require: true
    },
  },
  computed: {
    searchIsVisible: {
      set (str) {
        this.handleQuery({
          is_visible: str
        })
      },
      get () {
        return this.is_visible
      }
    },
    searchKeyword: {
      set (str) {
        this.handleQuery({
          keyword: str
        })
      },
      get () {
        return this.keyword
      }
    },
  },
  methods: {
    handleQuery (obj) {
      this.$emit('handleQuery', obj)
    },
    handleRefresh () {
      this.$emit('handleRefresh')
    },
    handleAdd () {
      this.$router.push('domain/add')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-container{margin-right: 100px;}
.el-form-item{margin-bottom: 0!important;}
</style>
